import React, {
    createRef,
    LegacyRef,
    Ref,
    RefObject,
    useCallback,
    useEffect,
    useRef,
    useState,
    useImperativeHandle,
    forwardRef,
} from 'react'
import LuxButton from '../buttons/Button'
import {
    Stage,
    Layer,
    Rect,
    Text,
    Circle,
    Group,
    Image as KImage,
    Label,
    Tag,
} from 'react-konva'
import isArray from 'lodash'
import useImage from 'use-image'
import Konva from 'konva'
import './form.scss'
import { AreaInputUrlImage } from './AreaInputUrlImage'

interface AreaInputProps {
    image: string
    width: number
    height: number
    containerClasses: string
    onChangeCallback: (data: any) => void
    onCanvasBlob: (canvasName: string, blob: any) => void
    onCanvasFile: (canvasName: string, file: File) => void
    value: any
    images?: any[]
    labels?: any[]
    bullets?: any[]
    maxNumber?: number
    fillColor?: string
    strokeColor?: string
    lineWidth?: number
    canvasName?: string
    text?: string
    label?: string
    subLabel?: string
    parentOverflow?: string
    isEditingCanvas?: (editing: boolean) => void
    isEditingCanvasArea?: (editing: boolean) => void
    isEditingCanvasImages?: (editing: boolean) => void
    isEditingCanvasLabels?: (editing: boolean) => void
    onItemDragEnd?: (e: any, item: any, targetMode: any, index: number) => void
    onDepartmentSelected?: (e: any, item: any) => void
    onRemovePoints?: (
        item: any,
        index: number,
        targetMode: AREAINPUT_MODE
    ) => void
    alwaysEditable?: boolean
    onClickCallback?: any
    setAreaLabel?: string
    setImagesLabel?: string
    setLabelsLabel?: string
    setBulletsLabel?: string
    disableAddBullet?: boolean
    disableAddLabel?: boolean
    hideApplyButton?: boolean
    readOnly?: boolean
    areaBackground?: any
    buttonsPosition?: 'top' | 'bottom'
    additionalButtons?: any
    showDepartmentConf?: boolean
    configurations?: any[]
    genderImage?: any
    commodityImage?: any
}

export enum AREAINPUT_MODE {
    AREA = 'AREA',
    IMAGES = 'IMAGES',
    LABELS = 'LABELS',
    BULLETS = 'BULLETS',
}

const AreaInput = (props: AreaInputProps, ref) => {
    const {
        image,
        width,
        height,
        images,
        labels,
        bullets,
        onChangeCallback,
        onCanvasBlob,
        onCanvasFile,
        containerClasses,
        value,
        maxNumber,
        strokeColor,
        fillColor,
        lineWidth,
        text,
        label,
        subLabel,
        canvasName,
        parentOverflow,
        isEditingCanvas,
        isEditingCanvasArea,
        isEditingCanvasImages,
        isEditingCanvasLabels,
        onDepartmentSelected,
        alwaysEditable,
        onClickCallback,
        setAreaLabel,
        setImagesLabel,
        setLabelsLabel,
        disableAddLabel,
        hideApplyButton,
        buttonsPosition,
        onItemDragEnd,
        readOnly,
        onRemovePoints,
        areaBackground,
        additionalButtons,
        showDepartmentConf,
        configurations,
        genderImage,
        commodityImage,
    } = props

    // const [disabled, setDisabled] = useState(true)
    const [_lineWidth, _setLineWidth] = useState(2)
    const [_maxNumber, _setMaxNumber] = useState(3)
    const [_strokeColor, _setStrokeColor] = useState<string>(
        getComputedStyle(document.body).getPropertyValue('--lux-primary').trim()
    )
    const [_fillColor, _setFillColor] = useState<string>(
        getComputedStyle(document.body)
            .getPropertyValue('--lux-primary-translucent')
            .trim()
    )

    const [_text, _setText] = useState<string>()
    const [isEditing, setIsEditing] = useState(false)
    const [isEditingArea, setIsEditingArea] = useState(false)
    const [isEditingImages, setIsEditingImages] = useState(false)
    const [isEditingLabels, setIsEditingLabels] = useState(false)
    const [oldValue, setOldValue] = useState([])

    const [annotations, setAnnotations] = useState([])
    const [newAnnotation, setNewAnnotation] = useState([])

    const [_images, setImages] = useState([])

    const [_labels, setLabels] = useState([])
    const [newLabels, setNewLabels] = useState([])

    const [_bullets, setBullets] = useState([])
    const [newBullets, setNewBullets] = useState([])

    const [imagesRefs, setImagesRefs] = React.useState([])
    const [labelsRefs, setLabelsRefs] = React.useState([])
    const [bulletsRefs, setBulletsRefs] = React.useState([])
    const [bgImage, status] = useImage(image, 'anonymous')

    const [genderIcon, genderStatus] = useImage(
        'https://i.ibb.co/5nfFkWp/gender-color.png',
        'anonymous'
    )
    const [commodityIcon, commodityStatus] = useImage(
        'https://i.ibb.co/3hHY11g/sun-optical-color.png',
        'anonymous'
    )

    // const [genderIcon, genderStatus] = useImage(
    //     'https://i.ibb.co/2gKLNwz/gender.png',
    //     'anonymous'
    // )
    // const [commodityIcon, commodityStatus] = useImage(
    //     'https://i.ibb.co/MscZbjk/s-o.png',
    //     'anonymous'
    // )
    const [isImageLoaded, setIsImageLoaded] = useState(false)

    const [_buttonsPosition, _setButtonsPosition] = useState(
        buttonsPosition || 'top'
    )

    const [areaBg, setAreaBg] = useState<any>('rgb(46 82 143 / 74%)')
    const stageRef = React.useRef(null)

    const config = () => {
        if (maxNumber) {
            _setMaxNumber(maxNumber + 1)
        }
        if (fillColor) {
            _setFillColor(fillColor)
        }
        if (strokeColor) {
            _setStrokeColor(strokeColor)
        }
        if (lineWidth) {
            _setLineWidth(lineWidth)
        }
    }

    useEffect(() => {
        config()
        _setButtonsPosition(buttonsPosition || 'top')
    }, [])

    useEffect(() => {
        if (areaBackground) {
            setAreaBg(areaBackground)
        }
    }, [areaBackground])

    useEffect(() => {
        let tmpArray = []
        if (value && isArray(value)) {
            tmpArray = JSON.parse(JSON.stringify(value))
            for (var i in value) {
                tmpArray[i].width = value[i].x2
                tmpArray[i].height = value[i].y2
                tmpArray[i].x = value[i].x1
                tmpArray[i].y = value[i].y1
                tmpArray[i].key = parseInt(i)
            }

            setAnnotations([...tmpArray])

            if (canvasName && (onCanvasBlob || onCanvasFile)) {
                // stageRef.current.container().style.backgroundColor = 'white'

                let base64 = stageRef.current.toDataURL({
                    quality: 0.5,
                    mimeType: 'image/png',
                })
                console.log('CANVAS IMAGE', base64)
                if (onCanvasBlob) {
                    let blob = base64toBlob(
                        base64.replace(
                            /^data:image\/(png|jpeg|jpg);base64,/,
                            ''
                        ),
                        'image/png'
                    )
                    console.log('CANVAS BLOB', blob)
                    if (blob) {
                        onCanvasBlob(canvasName, blob)
                    }
                } else if (onCanvasFile) {
                    let filename = new Date().getTime() + '.png'
                    let file = dataURLtoFile(base64, filename)
                    onCanvasFile(canvasName, file)
                }
            }
        }
    }, [value, text, isImageLoaded])

    useEffect(() => {
        if (images) {
            setImages(images)
            // setImages(newImages)
            setImagesRefs(
                images.map((_: any, i: any) => imagesRefs[i] || createRef())
            )
        }
        if (labels) {
            setLabels(labels)
            setLabelsRefs(
                labels.map((_: any, i: any) => labelsRefs[i] || createRef())
            )
        }
        if (bullets) {
            setBullets(bullets)
            setBulletsRefs(
                bullets.map((_: any, i: any) => bulletsRefs[i] || createRef())
            )
        }
    }, [images, labels, bullets])

    function loadSprite(src, callback) {
        var sprite = new Image()
        sprite.onload = () => callback(true)
        sprite.src = src
    }

    useEffect(() => {
        if (bgImage && bgImage.src) {
            loadSprite(bgImage.src, setIsImageLoaded)
        }
    }, [bgImage, bgImage?.src])

    useImperativeHandle(
        ref,
        () => ({
            getCanvas() {
                if (canvasName && (onCanvasBlob || onCanvasFile)) {
                    // stageRef.current.container().style.backgroundColor = 'white'

                    let base64 = stageRef.current.toDataURL({
                        quality: 0.5,
                        mimeType: 'image/jpeg',
                    })
                    console.log('CANVAS IMAGE', base64)
                    if (onCanvasBlob) {
                        let blob = base64toBlob(
                            base64.replace(
                                /^data:image\/(png|jpeg|jpg);base64,/,
                                ''
                            ),
                            'image/jpeg'
                        )
                        console.log('CANVAS BLOB', blob)
                        if (blob) {
                            onCanvasBlob(canvasName, blob)
                        }
                    } else if (onCanvasFile) {
                        let filename = new Date().getTime() + '.jpg'
                        let file = dataURLtoFile(base64, filename)
                        onCanvasFile(canvasName, file)
                    }
                }
            },
        }),
        []
    )

    const _setIsEditing = (editing: boolean) => {
        setIsEditing(editing)
        isEditingCanvas(editing)
    }
    const _setIsEditingArea = (editing: boolean) => {
        setIsEditingArea(editing)
        if (isEditingCanvasArea) {
            isEditingCanvasArea(editing)
        }
    }
    const _setIsEditingImages = (editing: boolean) => {
        setIsEditingImages(editing)
        isEditingCanvasImages(editing)
    }
    const _setIsEditingLabels = (editing: boolean) => {
        setIsEditingLabels(editing)
        isEditingCanvasLabels(editing)
    }

    const hit = (rect, x, y) => {
        // console.log('CHECKING', rect, x, y)
        return (
            x >= rect.x - 15 &&
            x <= rect.x + 15 &&
            y >= rect.y - 15 &&
            y <= rect.y + 15
        )
    }

    const getFontSize = (width) => {
        let fontsize = 18
        width = width < 0 ? -width : width
        let canvas = document.createElement('canvas')

        if (canvas) {
            let ctx = canvas.getContext('2d')
            do {
                fontsize--
            } while (ctx.measureText(text).width > width - 10)
        }
        // debugger
        return fontsize
    }

    const getTextXPos = (x, width) => {
        let fontsize = getFontSize(width)
        return x + width / 2 - fontsize
    }

    const handleMouseDown = (event) => {
        if (!isEditing && !alwaysEditable) return
        if (newAnnotation.length === 0) {
            const { x, y } = event.target.getStage().getPointerPosition()
            let del = false
            for (var i in annotations) {
                if (hit(annotations[i], x, y)) {
                    del = true
                    break
                }
            }

            if (!del) {
                setNewAnnotation([{ x, y, width: 0, height: 0, key: '0' }])
            }
        }
    }

    const handleMouseUp = (event) => {
        if (!isEditing && !alwaysEditable) return
        if (newAnnotation.length === 1) {
            const sx = newAnnotation[0].x
            const sy = newAnnotation[0].y
            const { x, y } = event.target.getStage().getPointerPosition()
            if (x - sx > 10 || x - sx < -10) {
                const annotationToAdd = {
                    x: sx,
                    y: sy,
                    width: x - sx,
                    height: y - sy,
                    key: annotations.length + 1,
                }
                annotations.push(annotationToAdd)
                setNewAnnotation([])
                setAnnotations(annotations)
                // console.log('LAST ANNOTATION', annotationToAdd)
            } else {
                setNewAnnotation([])
            }
        }
    }

    const handleMouseMove = (event) => {
        if (!isEditing && !alwaysEditable) return
        if (newAnnotation.length === 1) {
            const sx = newAnnotation[0].x
            const sy = newAnnotation[0].y
            const { x, y } = event.target.getStage().getPointerPosition()
            setNewAnnotation([
                {
                    x: sx,
                    y: sy,
                    width: x - sx,
                    height: y - sy,
                    key: '0',
                },
            ])
        }
    }

    const removeItem = (index: any): void => {
        if (!isEditing && !alwaysEditable) return
        let tmpArray = [...annotations, ...newAnnotation]
        if (index > annotations.length) {
            let i = index - (annotations.length - 1)
            tmpArray.splice(i, 1)
            setNewAnnotation([])
        } else {
            tmpArray.splice(index, 1)
            setAnnotations([...tmpArray])
        }
    }

    const removePoints = (
        item: any,
        index: any,
        targetMode: AREAINPUT_MODE
    ): void => {
        // if (!isEditing && !alwaysEditable) return
        if (onRemovePoints) {
            onRemovePoints(item, index, targetMode)
        }
    }

    const base64toBlob = (base64Data: string, contentType: string) => {
        contentType = contentType || ''
        var sliceSize = 1024
        var byteCharacters = atob(base64Data)
        var bytesLength = byteCharacters.length
        var slicesCount = Math.ceil(bytesLength / sliceSize)
        var byteArrays = new Array(slicesCount)

        for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            var begin = sliceIndex * sliceSize
            var end = Math.min(begin + sliceSize, bytesLength)

            var bytes = new Array(end - begin)
            for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0)
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes)
        }
        return new Blob(byteArrays, { type: contentType })
    }

    const dataURLtoFile = (dataurl: string, filename: string) => {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n)

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
        }

        return new File([u8arr], filename, { type: mime })
    }

    const setCursorOnRemoveButtonHover = (
        hover?: boolean,
        draggable?: boolean
    ) => {
        ;(
            stageRef.current as Konva.Stage
        ).getAttrs().container.style.cursor = `${
            isEditing ||
            alwaysEditable ||
            draggable ||
            isEditingImages ||
            isEditingLabels ||
            onDepartmentSelected
                ? hover
                    ? 'pointer'
                    : 'crosshair'
                : 'not-allowed'
        }`
    }

    const onCanvasClick = (e: any) => {
        onClickCallback(e)
    }

    const handleDragEnd = (
        e: any,
        item: any,
        targetMode: AREAINPUT_MODE,
        index: number
    ) => {
        e.width = width
        e.height = height

        if (e.target) {
            let relativePointerPosition = (
                e.target as Konva.Group
            ).getRelativePointerPosition()
            e.relativeOffset = { x: 0, y: 0 }
            if (
                relativePointerPosition &&
                typeof relativePointerPosition.x === 'number' &&
                typeof relativePointerPosition.y === 'number'
            ) {
                e.relativeOffset = relativePointerPosition
            }
        }
        // console.log('DRAG EVENT BEFORE', e)

        if (onItemDragEnd) {
            // debugger
            onItemDragEnd(e, item, targetMode, index)
        }
    }

    const onDepartmentClicked = (e: any, item: any) => {
        // console.log('DEPARTMENT SELECTED', item)
        onDepartmentSelected(e, item)
        // item.selected = !item.selected
    }

    const annotationsToDraw = [...annotations, ...newAnnotation]
    const imagesToDraw = [..._images]
    const labelsToDraw = [..._labels]
    const bulletsToDraw = [..._bullets]

    const renderButtons = () => {
        // console.log(additionalButtons)
        return (
            <div className="flex flex-direction-column mt-2">
                {(isEditing ||
                    (isEditingArea &&
                        (isEditingCanvasArea || isEditingCanvas)) ||
                    alwaysEditable) && (
                    <LuxButton
                        classes="mt-3"
                        text="Apply"
                        disabled={!annotations}
                        onClick={(e: any) => {
                            let array = [...annotations, ...newAnnotation]
                            let tmpArray = []
                            for (var i in array) {
                                tmpArray.push({
                                    x1: array[i].x,
                                    x2: array[i].width,
                                    y1: array[i].y,
                                    y2: array[i].height,
                                    width: width,
                                    height: height,
                                })
                            }
                            e.value = [...tmpArray]
                            e.targetMode = AREAINPUT_MODE.AREA
                            onChangeCallback(e)
                            _setIsEditing(false)
                            _setIsEditingArea(false)
                        }}
                    />
                )}
                {!isEditing &&
                    !isEditingArea &&
                    (isEditingCanvasArea || isEditingCanvas) &&
                    !alwaysEditable && (
                        <LuxButton
                            disabled={isEditingImages || isEditingLabels}
                            classes="mt-3"
                            text={`${setAreaLabel ? setAreaLabel : 'Set Area'}`}
                            onClick={(e: any) => {
                                _setIsEditing(true)
                                _setIsEditingArea(true)
                            }}
                        />
                    )}

                {(isEditingImages || alwaysEditable) && !hideApplyButton && (
                    <LuxButton
                        classes="mt-3"
                        text="Apply"
                        disabled={!annotations}
                        onClick={(e: any) => {
                            let array = [...images]
                            let tmpArray = []
                            for (var i in array) {
                                tmpArray.push({
                                    x1: array[i].x,
                                    x2: array[i].width,
                                    y1: array[i].y,
                                    y2: array[i].height,
                                    width: width,
                                    height: height,
                                    img: array[i]?.logo,
                                })
                            }
                            e.value = [...tmpArray]
                            e.targetMode = AREAINPUT_MODE.IMAGES
                            onChangeCallback(e)
                            _setIsEditingImages(false)
                        }}
                    />
                )}
                {isEditingCanvasImages && !alwaysEditable && (
                    <LuxButton
                        disabled={isEditingArea || isEditing || isEditingLabels}
                        classes="mt-3"
                        text={`${
                            isEditingImages
                                ? 'Click on the map to add an item'
                                : setImagesLabel
                                ? setImagesLabel
                                : 'Set Points'
                        }`}
                        onClick={(e: any) => {
                            if (!isEditingImages) {
                                _setIsEditingImages(true)
                            }
                        }}
                    />
                )}

                {(isEditingLabels || alwaysEditable) && !hideApplyButton && (
                    <LuxButton
                        classes="mt-3"
                        text="Apply"
                        disabled={!annotations}
                        onClick={(e: any) => {
                            let array = [...labels, ...newLabels]
                            let tmpArray = []
                            for (var i in array) {
                                tmpArray.push({
                                    x1: array[i].x,
                                    x2: array[i].width,
                                    y1: array[i].y,
                                    y2: array[i].height,
                                    width: width,
                                    height: height,
                                    text: array[i]?.text,
                                })
                            }
                            e.value = [...tmpArray]
                            e.targetMode = AREAINPUT_MODE.LABELS
                            onChangeCallback(e)
                            _setIsEditingLabels(false)
                        }}
                    />
                )}
                {isEditingCanvasLabels && !alwaysEditable && (
                    <LuxButton
                        classes="mt-3"
                        disabled={
                            isEditing ||
                            isEditingArea ||
                            isEditingImages ||
                            disableAddLabel
                        }
                        text={`${
                            isEditingLabels
                                ? 'Click on the map to add an item'
                                : setLabelsLabel
                                ? setLabelsLabel
                                : 'Set Labels'
                        }`}
                        onClick={(e: any) => {
                            if (!isEditingLabels) {
                                _setIsEditingLabels(true)
                            }
                        }}
                    />
                )}
                {additionalButtons && additionalButtons}
            </div>
        )
    }

    const getConfiguration = (department: any, index: any) => {
        if (!department || !configurations) return <></>

        let found = configurations.find(
            (item: any) =>
                item.macroArea?._id === department._id &&
                item.touchPoint?._id === department.touchPoint &&
                item.zone?._id === department.zone &&
                item.floor == department.floor &&
                item.floorplan === department.floorplan
        )

        // debugger

        if (found) {
            return (
                <Group
                    key={`'configuration_${department.touchPoint}_${department._id}_${index}`}
                    x={15}
                    y={40}>
                    {found.gender && (
                        <Group x={0} y={0}>
                            <Circle
                                key={`CIRCLE_configuration_${department.touchPoint}_${department._id}_gender`}
                                radius={10}
                                stroke={'rgb(35, 122, 201, 100%)'}
                                strokeWidth={1}
                                fill={'#d3d3d3'}
                            />
                            <KImage
                                image={genderIcon}
                                width={15}
                                height={15}
                                x={-7}
                                y={-7}
                                onMouseOver={() =>
                                    setCursorOnRemoveButtonHover(true)
                                }
                                onMouseOut={() =>
                                    setCursorOnRemoveButtonHover(false)
                                }
                            />
                        </Group>
                    )}
                    {found.commodity && (
                        <Group x={25}>
                            <Circle
                                key={`CIRCLE_configuration_${department.touchPoint}_${department._id}_commodity}`}
                                radius={10}
                                strokeWidth={1}
                                stroke={'rgb(35, 122, 201, 100%)'}
                                fill={'#d3d3d3'}
                            />
                            <KImage
                                image={commodityIcon}
                                width={15}
                                height={15}
                                x={-7}
                                y={-7}
                                onMouseOver={() =>
                                    setCursorOnRemoveButtonHover(true)
                                }
                                onMouseOut={() =>
                                    setCursorOnRemoveButtonHover(false)
                                }
                            />
                        </Group>
                    )}
                </Group>
            )
        }

        return <></>
    }

    return (
        <div
            style={{
                position: 'relative',
                margin: '0 auto',
                marginTop: '5px',
                paddingTop: '10px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
            }}
            className={``}>
            {label && <label className={`active`}>{label}</label>}
            {subLabel && (
                <label style={{ marginBottom: '0px' }} className={`active`}>
                    {subLabel}
                </label>
            )}
            {/*label && <label className={`active`}>{subLabel}</label>*/}

            {_buttonsPosition === 'top' && renderButtons()}

            <div
                style={{
                    position: 'relative',
                    display: 'flex',
                    margin: '0 auto',
                    marginTop: '15px',
                    width: `${width + 50}px`,
                    height: `${height + 50}px`,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
                className={containerClasses}>
                {/* <img src={image} width={width} height={height} /> */}
                {/* <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: width,
                        height: height,
                    }}>

                </div> */}

                <Stage
                    ref={stageRef}
                    onMouseDown={handleMouseDown}
                    onMouseUp={handleMouseUp}
                    onMouseMove={handleMouseMove}
                    {...(isEditingCanvasImages || isEditingCanvasLabels
                        ? {
                              onClick: (e: any) => {
                                  if (isEditingImages || isEditingLabels) {
                                      let targetMode = isEditingImages
                                          ? AREAINPUT_MODE.IMAGES
                                          : isEditingLabels
                                          ? AREAINPUT_MODE.LABELS
                                          : AREAINPUT_MODE.AREA
                                      e.targetMode = targetMode
                                      onCanvasClick(e)
                                      _setIsEditingImages(false)
                                      _setIsEditingLabels(false)
                                  }
                              },
                          }
                        : {})}
                    width={width + 50}
                    height={height + 50}
                    style={{
                        background: '#fff',
                        cursor: `${
                            isEditing ||
                            isEditingArea ||
                            isEditingImages ||
                            isEditingLabels ||
                            alwaysEditable
                                ? 'crosshair'
                                : 'not-allowed'
                        }`,
                    }}>
                    {/* <Layer
                        key={`LAYER_IMAGE`}
                        width={width}
                        height={height}></Layer> */}
                    <Layer
                        key={`LAYER_`}
                        style={{
                            background: '#fff',
                        }}>
                        <Rect key={`RECT_BG`} fill={`white`} />
                        <KImage
                            image={bgImage}
                            width={width}
                            height={height}
                            x={25}
                            y={25}
                        />

                        {annotationsToDraw.map((value, index) => {
                            return (
                                <>
                                    <Group>
                                        <Rect
                                            key={`RECT_${index}`}
                                            x={value.x}
                                            y={value.y}
                                            width={value.width}
                                            height={value.height}
                                            fill={areaBg}
                                            stroke={_strokeColor}
                                        />
                                        <Text
                                            key={`TEXT_${index}`}
                                            text={text}
                                            fontSize={12}
                                            ellipsis={true}
                                            shadowEnabled={true}
                                            shadowColor="#000"
                                            shadowBlur={3}
                                            align="center"
                                            fontFamily="Inter"
                                            width={
                                                value.width >= 0
                                                    ? value.width - 6
                                                    : -value.width - 6
                                            }
                                            x={
                                                value.width >= 0
                                                    ? value.x + 4
                                                    : value.x + value.width + 4
                                            }
                                            y={-9 + value.y + value.height / 2}
                                            fill="#fff"
                                        />
                                    </Group>
                                    {!isEditing ||
                                        (isEditingArea && (
                                            <Group>
                                                <Circle
                                                    onClick={(e: any) => {
                                                        removeItem(index)
                                                        setCursorOnRemoveButtonHover(
                                                            false
                                                        )
                                                    }}
                                                    key={`CIRCLE_${index}`}
                                                    radius={10}
                                                    fill={_strokeColor}
                                                    x={value.x}
                                                    y={value.y}
                                                    onMouseOver={() =>
                                                        setCursorOnRemoveButtonHover(
                                                            true
                                                        )
                                                    }
                                                    onMouseOut={() =>
                                                        setCursorOnRemoveButtonHover(
                                                            false
                                                        )
                                                    }
                                                />
                                                <Text
                                                    onClick={(e: any) => {
                                                        removeItem(index)
                                                        setCursorOnRemoveButtonHover(
                                                            false
                                                        )
                                                    }}
                                                    key={`TEXT2_${index}`}
                                                    text={`X`}
                                                    width={10}
                                                    height={10}
                                                    fontSize={10}
                                                    x={value.x - 3}
                                                    y={value.y - 4}
                                                    fill="#fff"
                                                    onMouseOver={() =>
                                                        setCursorOnRemoveButtonHover(
                                                            true
                                                        )
                                                    }
                                                    onMouseOut={() =>
                                                        setCursorOnRemoveButtonHover(
                                                            false
                                                        )
                                                    }
                                                />
                                            </Group>
                                        ))}
                                </>
                            )
                        })}

                        {imagesToDraw.map((value, index) => {
                            // console.log('images to draw', value)
                            return (
                                <>
                                    <Group
                                        ref={imagesRefs[index]}
                                        opacity={
                                            isEditingCanvasImages ? 1 : 0.7
                                        }
                                        draggable={
                                            isEditingCanvasImages ? true : false
                                        }
                                        x={value?.position?.x}
                                        y={value?.position?.y}
                                        onDragEnd={(e: any) => {
                                            handleDragEnd(
                                                e,
                                                value,
                                                AREAINPUT_MODE.IMAGES,
                                                index
                                            )
                                        }}>
                                        <AreaInputUrlImage
                                            key={`IMAGES_${index}`}
                                            src={value?.logo}
                                            width={40}
                                            height={40}
                                            {...(isEditingCanvasImages
                                                ? {
                                                      onMouseOver: () => {
                                                          setCursorOnRemoveButtonHover(
                                                              true,
                                                              true
                                                          )
                                                      },

                                                      onMouseOut: () => {
                                                          setCursorOnRemoveButtonHover(
                                                              false
                                                          )
                                                      },
                                                  }
                                                : {})}
                                        />
                                        {onRemovePoints &&
                                            isEditingCanvasImages && (
                                                <Group
                                                    x={5}
                                                    y={5}
                                                    onClick={(e: any) => {
                                                        removePoints(
                                                            value,
                                                            index,
                                                            AREAINPUT_MODE.IMAGES
                                                        )
                                                        setCursorOnRemoveButtonHover(
                                                            false
                                                        )
                                                    }}>
                                                    <Circle
                                                        key={`CIRCLE_${index}`}
                                                        radius={10}
                                                        fill={_strokeColor}
                                                        onMouseOver={() =>
                                                            setCursorOnRemoveButtonHover(
                                                                true,
                                                                true
                                                            )
                                                        }
                                                        onMouseOut={() =>
                                                            setCursorOnRemoveButtonHover(
                                                                false
                                                            )
                                                        }
                                                    />
                                                    <Text
                                                        key={`TEXT2_${index}`}
                                                        text={`X`}
                                                        width={10}
                                                        height={10}
                                                        fontSize={10}
                                                        x={-3}
                                                        y={-3}
                                                        fill="#fff"
                                                        onMouseOver={() =>
                                                            setCursorOnRemoveButtonHover(
                                                                true,
                                                                true
                                                            )
                                                        }
                                                        onMouseOut={() =>
                                                            setCursorOnRemoveButtonHover(
                                                                false
                                                            )
                                                        }
                                                    />
                                                </Group>
                                            )}
                                    </Group>
                                </>
                            )
                        })}

                        {labelsToDraw.map((value, index) => {
                            // console.log('label to draw', value)
                            return (
                                <>
                                    {/* <Rect
                                            key={`RECT_${index}`}
                                            x={value.x}
                                            y={value.y}
                                            width={value.width}
                                            height={value.height}
                                            fill={`rgb(46 82 143 / 74%)`}
                                            stroke={_strokeColor}
                                        /> */}
                                    <Group
                                        ref={labelsRefs[index]}
                                        draggable={
                                            isEditingCanvasLabels ? true : false
                                        }
                                        onDragEnd={(e: any) => {
                                            handleDragEnd(
                                                e,
                                                value,
                                                AREAINPUT_MODE.LABELS,
                                                index
                                            )
                                        }}
                                        {...(onDepartmentSelected
                                            ? {
                                                  onClick: (e: any) => {
                                                      onDepartmentClicked(
                                                          e,
                                                          value
                                                      )
                                                  },
                                              }
                                            : {})}
                                        x={value?.position?.x}
                                        y={value?.position?.y}>
                                        <Label
                                            height={10}
                                            {...(isEditingCanvasLabels ||
                                            onDepartmentSelected
                                                ? {
                                                      onMouseOver: () => {
                                                          setCursorOnRemoveButtonHover(
                                                              true,
                                                              true
                                                          )
                                                      },

                                                      onMouseOut: () => {
                                                          setCursorOnRemoveButtonHover(
                                                              false
                                                          )
                                                      },
                                                  }
                                                : {})}>
                                            <Tag
                                                fill={`rgb(35, 122, 201, ${
                                                    isEditingCanvasLabels ||
                                                    showDepartmentConf
                                                        ? '100%'
                                                        : '74%'
                                                })`}
                                                lineJoin="round"
                                                cornerRadius={10}
                                            />
                                            <Text
                                                key={`LABELS_${index}`}
                                                text={value?.name}
                                                fontSize={13}
                                                fontFamily="Inter"
                                                padding={10}
                                                opacity={
                                                    isEditingCanvasLabels ||
                                                    value.selected
                                                        ? 1
                                                        : 0.7
                                                }
                                                fill="#fff"
                                            />
                                        </Label>

                                        {showDepartmentConf &&
                                            configurations &&
                                            getConfiguration(value, index)}

                                        {onRemovePoints &&
                                            isEditingCanvasLabels && (
                                                <Group
                                                    onClick={(e: any) => {
                                                        removePoints(
                                                            value,
                                                            index,
                                                            AREAINPUT_MODE.LABELS
                                                        )
                                                        setCursorOnRemoveButtonHover(
                                                            false
                                                        )
                                                    }}
                                                    x={3}
                                                    y={3}>
                                                    <Circle
                                                        key={`CIRCLE_${index}`}
                                                        radius={10}
                                                        fill={_strokeColor}
                                                        onMouseOver={() =>
                                                            setCursorOnRemoveButtonHover(
                                                                true,
                                                                true
                                                            )
                                                        }
                                                        onMouseOut={() =>
                                                            setCursorOnRemoveButtonHover(
                                                                false
                                                            )
                                                        }
                                                    />
                                                    <Text
                                                        key={`TEXT2_${index}`}
                                                        text={`X`}
                                                        width={10}
                                                        height={10}
                                                        fontSize={10}
                                                        x={-4}
                                                        y={-4}
                                                        fill="#fff"
                                                        onMouseOver={() =>
                                                            setCursorOnRemoveButtonHover(
                                                                true,
                                                                true
                                                            )
                                                        }
                                                        onMouseOut={() =>
                                                            setCursorOnRemoveButtonHover(
                                                                false
                                                            )
                                                        }
                                                    />
                                                </Group>
                                            )}
                                    </Group>
                                </>
                            )
                        })}

                        {bulletsToDraw.map((value, index) => {
                            // console.log('bullets to draw', value)
                            if (
                                !value.position ||
                                !value.position.x ||
                                !value.position.y
                            ) {
                                return <></>
                            }
                            return (
                                <>
                                    {/* <Rect
                                            key={`RECT_${index}`}
                                            x={value.x}
                                            y={value.y}
                                            width={value.width}
                                            height={value.height}
                                            fill={`rgb(46 82 143 / 74%)`}
                                            stroke={_strokeColor}
                                        /> */}
                                    <Group
                                        ref={bulletsRefs[index]}
                                        draggable={true}
                                        x={value?.position?.x}
                                        y={value?.position?.y}
                                        onDragEnd={(e: any) => {
                                            handleDragEnd(
                                                e,
                                                value,
                                                AREAINPUT_MODE.BULLETS,
                                                index
                                            )
                                        }}>
                                        <Label
                                            height={10}
                                            onMouseOver={() =>
                                                setCursorOnRemoveButtonHover(
                                                    true,
                                                    true
                                                )
                                            }
                                            onMouseOut={() =>
                                                setCursorOnRemoveButtonHover(
                                                    false
                                                )
                                            }>
                                            <Tag
                                                fill="black"
                                                lineJoin="round"
                                                cornerRadius={10}
                                            />
                                            <Text
                                                key={`BULLETS_${index}`}
                                                text={value?.idF}
                                                fontSize={13}
                                                fontFamily="Inter"
                                                padding={10}
                                                wrap="none"
                                                ellipsis={true}
                                                fill="#fff"
                                            />
                                        </Label>
                                        {onRemovePoints && (
                                            <Group
                                                x={3}
                                                y={3}
                                                onClick={(e: any) => {
                                                    removePoints(
                                                        value,
                                                        index,
                                                        AREAINPUT_MODE.BULLETS
                                                    )
                                                    setCursorOnRemoveButtonHover(
                                                        false
                                                    )
                                                }}>
                                                <Circle
                                                    key={`BULLETS_CIRCLE_${index}`}
                                                    radius={10}
                                                    fill={_strokeColor}
                                                    onMouseOver={() =>
                                                        setCursorOnRemoveButtonHover(
                                                            true,
                                                            true
                                                        )
                                                    }
                                                    onMouseOut={() =>
                                                        setCursorOnRemoveButtonHover(
                                                            false
                                                        )
                                                    }
                                                />
                                                <Text
                                                    key={`BULLETS_TEXT2_${index}`}
                                                    text={`X`}
                                                    width={10}
                                                    height={10}
                                                    fontSize={10}
                                                    fill="#fff"
                                                    x={-4}
                                                    y={-4}
                                                    onMouseOver={() =>
                                                        setCursorOnRemoveButtonHover(
                                                            true,
                                                            true
                                                        )
                                                    }
                                                    onMouseOut={() =>
                                                        setCursorOnRemoveButtonHover(
                                                            false
                                                        )
                                                    }
                                                />
                                            </Group>
                                        )}
                                    </Group>
                                </>
                            )
                        })}
                    </Layer>
                </Stage>
            </div>
            {_buttonsPosition === 'bottom' && renderButtons()}
        </div>
    )
}

export default forwardRef(AreaInput)
